/*
 * @Author: libo 
 * @Date: 2020-11-13 17:26:14 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-06 19:13:20
 */

<!--批量导入界面-->
<template>
  <a-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    :maskClosable="maskClosable"
    @ok="handleOk"
    @cancel="handleCancel"
    
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <div style="margin-bottom: 20px">
        <a-radio-group  v-model="meterImportType" @change="changeMeterImportType">
          <a-radio :value="1">
            {{ $t('按出厂订单编号导入') }}
          </a-radio>
          <a-radio :value="2">
            {{ $t('按Excel导入') }}
          </a-radio>
        </a-radio-group>
      </div>
      <div v-if="meterImportType === 1">
        <a-row :gutter="24">
          <a-form-model ref="queryParam" :model="queryParam" :rules="rules" :colon="false">
            <a-col :xl="8" :lg="7" :md="8" :sm="24">
              <a-form-model-item :label="$t('出厂订单编号')" prop="orderNo">
                <a-input :placeholder="$t('请输入出厂订单编号')" v-model="queryParam.orderNo"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :xl="8" :lg="7" :md="8" :sm="24">
              <a-form-model-item label=" ">
                <a-button type="primary" block @click="queryMeterProductByOrderId">
                  {{ $t('查询') }}
                </a-button>
              </a-form-model-item>
            </a-col>
          </a-form-model>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="24">
            <a-spin :spinning ="serarchMeterLoading">
              <h2 style="color: green">{{ $t('表具总数') }}: {{orderMeterResult.totalMeterCount}}</h2>
            </a-spin>
          </a-col>
          <a-form-model ref="formModal" :model="formModel" :rules="formModalRules" :colon="false">
            <a-col :xl="8" :lg="7" :md="8" :sm="24">
              <a-form-model-item :label="$t('表类型')" prop="mtCode">
                <a-select :placeholder="$t('请选择表类型')" v-model="formModel.mtCode" >
                  <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                    {{data.mtCode}}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :xl="8" :lg="7" :md="8" :sm="24">
              <a-form-model-item :label="$t('表口径')" prop="mtCaliber">
                <a-select v-model="formModel.mtCaliber" :placeholder="$t('请选择表口径')">
                  <a-select-option v-for="data in userCaliberList" :key="data.mtCaliber" :value="data.mtCaliber">
                    DN{{data.mtCaliber}}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="4">
              <a-form-model-item label=" ">
                <a-button @click="batchAddMeterByOrderId()" type="primary">
                  {{ $t('批量导入') }}
                </a-button>
              </a-form-model-item>
            </a-col>
          </a-form-model>
        </a-row>
      </div>
      <div v-else-if="meterImportType === 2">
        <a-form-model ref="formModal" :model="model" :rules="rules" :colon="false" layout="vertical">
            <div>
                <a-row :gutter="24">
                    <a-col :span="24">
                        <a-form-model-item :label="$t('上传文件')">
                            <a-upload name="file"
                                :multiple="false"
                                accept=".xls"
                                :fileList="fileList"
                                :headers="tokenHeader"
                                :beforeUpload="beforeUpload"
                                :remove="handleRemove"
                                >
                                <a-button>
                                    <a-icon type="upload" />
                                    {{ $t('选择导入文件') }}
                                </a-button>
                            </a-upload>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="24">
                    <a-col :xl="8" :lg="7" :md="8" :sm="24">
                        <a-form-model-item :label="$t('任务名称')" prop="taskName">
                            <a-input :placeholder="$t('请输入任务名称')" v-model="model.taskName"></a-input>
                        </a-form-model-item>
                    </a-col>
                    <a-col :xl="24" :lg="24" :md="24" :sm="24">
                        <a-form-model-item :label="$t('描述')" prop="remark">
                            <a-textarea v-model="model.remark" rows="3" :placeholder="$t('请输入备注')" style="width:100%"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </div>
        </a-form-model>
        <a-row :gutter="24">
          <a-col :span="10">
            <a-button type="link" icon="download" @click="downloadFormWork($t('批量报装模板'))">{{ $t('下载模板') }}</a-button>
          </a-col>
          <a-col :span="4">
            <a-button @click="handleSubmit()" type="primary">
              {{ $t('批量导入') }}
            </a-button>
          </a-col>
        </a-row>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
  import { listSize } from '@/utils/util'
  import { getAction,postAction } from '@/api/manage'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import {fileUrl} from'@/utils/util'
  import Vue from 'vue'
  const data = [];
  export default {
    name: 'MeterImportModal',
    components: {
    },
    data () {
      return {
        data,
        visible: false,
        disableSubmit:false,
        tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
        maskClosable:false,
        model: {},
        queryParam:{
          orderNo:'',//订单编号
        },

        confirmLoading: false,

        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfo/edit",
          batchAddMeterByOrderId: "/jeecg-charge/meter/meterBatchTaskRecord/batchAddMeterByOrderId",
          queryMeterProductByOrderId:"/jeecg-charge/meter/meterBatchTaskRecord/queryMeterProductByOrderId", //查询
          userTypeList:"/jeecg-charge/meter/meterType/list",  //表类型
          userCaliberList:"/jeecg-charge/meter/meterCaliber/list" ,  //表口径
          importExcelUrl: "jeecg-charge/meter/meterBatchTaskRecord/batchAddMeterByExcel",//导入
        },
        userTypeList:[], //表类型
        userCaliberList:[], //表口径
        meterImportType: 2,
        fileList: [],
        formModel: {mtCaliber: '',mtCode: ''},
        orderMeterResult: {totalMeterCount: 0,orderNo: ''},
        serarchMeterLoading: false,
      }
    },
    computed: {
      title() {
        return this.$t('操作')
      },
      rules() {
        return {
          taskName:[{ required: true, message: this.$t('请输入任务名称')}], //订单编号
        }
      },
      formModalRules() {
        return {
          mtCode:[{ required: true, message: this.$t('请输入表类型')}], //表类型
          mtCaliber:[{ required: true, message: this.$t('请输入表口径')}], //表口径
        }
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    created () {
      
    },
    methods: {
      handleSubmit() {
        const that = this;
        // 触发表单验证
        if(this.fileList.length==0) {
          this.$message.error(this.$t("请先选择上传文件"))
          return
        }
        this.$refs.formModal.validate(valid => {
          if(valid) {
            this.handleUpload()
          }else{
            return false
          }
        })
      },
      handleUpload() {
        this.confirmLoading = true
        const { fileList } = this;
        let formData = new FormData();
        //formData = Object.assign(formData,this.model)
        formData.append('taskName', this.model.taskName);
        formData.append('taskType', 1);
        if(this.model.remark) {
          formData.append('remark', this.model.remark);
        }
        
        fileList.forEach((file) => {
          formData.append('file', file);
        });
        postAction(this.importExcelUrl, formData).then((res) => {
          this.confirmLoading = false
          if(res.success){
            this.$message.success(res.message || this.$t('批量导入成功'))
            this.$emit('ok')
            this.close()
          }else{
            this.$message.warning(res.message)
          }
        })
      },
      handleRemove(file) {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      },
      beforeUpload(file) {
        // 只支持Excel,
        let fileName = file.name;
        let fileType = fileName.substring(fileName.lastIndexOf("."),fileName.length);
        if(fileType!='.xls') {
          this.$message.error(this.$t("只支持.xls格式文件！"))
          return false;
        }else{
          this.fileList = [file];
          return false;
        }
      },
      queryUserTypeList() {   //表类型请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userTypeList, params).then((res) => {
          if(res.success){
            this.userTypeList = res.result.records;
            console.log(this.userTypeList);
          }
        }) 
      },
      queryUserCaliberList() {   //表口径请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.column = 'mtCaliber';
        params.order = 'asc';
        getAction(this.url.userCaliberList, params).then((res) => {
          if(res.success){
            this.userCaliberList = res.result.records;
            console.log(this.userCaliberList);
          }
        }) 
      },
      add() {
        this.edit({});
      },
      edit (record) { 
        console.log("编辑")
        this.visible = true;
        this.queryUserTypeList();
        this.queryUserCaliberList();
      },
      handleOk(){},
      queryMeterProductByOrderId () {
        this.orderMeterResult = this.$options.data.call(this).orderMeterResult
        const that = this;
        // 触发表单验证
        this.$refs.queryParam.validate(valid => {
          if (valid) {
            this.serarchMeterLoading = true
            let formData = Object.assign({},that.queryParam)
            formData.orderNo = this.queryParam.orderNo
            //formData.mtCode = this.queryParam.mtCode
            //formData.mtCaliber = this.queryParam.mtCaliber
            getAction(this.url.queryMeterProductByOrderId,formData).then((res)=>{
              if(res.success){
                if (res.result.totalMeterCount==0) {
                  const h = this.$createElement;
                  this.$info({
                    title: this.$t('消息?'),
                    content: h('div', {}, [
                      h('p', this.$t('当前订单编号未查询到表具信息,请核对订单编号是否正确！')),
                    ]),
                    onOk() {},
                  });
                } else {
                  this.orderMeterResult = res.result
                  /*
                  let str = '该出厂订单编号下共查询到:'
                  let str1 = res.result.totalMeterCount
                  let str2 = '块表,确定要导入吗？'
                  this.$confirm({
                    title: '确认导入?',
                    content: h => <div >{str}<span style="color:red;font-size:18px">{str1}</span>{str2}</div>,
                    onOk() {
                      console.log('进入导入');
                      that.close();
                      that.batchAddMeterByOrderId(res.result);
                    },
                    onCancel() {
                    },
                    class: 'test',
                  });
                  */
                }
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.serarchMeterLoading = false;
            })
          }
        })
      },
      batchAddMeterByOrderId() {   //导入表
        if(this.orderMeterResult.totalMeterCount<=0) {
          this.$message.warning(this.$t("表具数量为0，请先查询"));
          return
        }
        this.$refs.formModal.validate(valid => {
          if (valid) {
            this.confirmLoading = true
            let result = this.orderMeterResult
            let params = {}
            params.orderNo = result.orderNo;
            params.mtCode = this.formModel.mtCode;
            params.mtCaliber = this.formModel.mtCaliber;
            postAction(this.url.batchAddMeterByOrderId, params).then((res) => {
              if(res.success){
                this.$message.success(this.$t("添加成功,请至【辅助服务--批量任务列表】去查看执行结果"));
                this.$emit('ok');
                this.close();
              } else {
                this.$message.warning(res.result);
              }
            }).finally(()=> {
              this.confirmLoading = false
            })
          }
        })
        
      },
      shut(){
        this.queryParam = this.$options.data.call(this).queryParam
        this.model = this.$options.data.call(this).model
        this.orderMeterResult = this.$options.data.call(this).orderMeterResult
        this.formModel = this.$options.data.call(this).formModel
        this.$refs.formModal.resetFields()
        this.fileList = []
        this.meterImportType = 1
      },
      close () {
        this.$emit('close');
        this.shut();
        this.disableSubmit = false;
        this.visible = false;
        
      },
      downloadFormWork(fileName) {
        console.log("下载批量报装模板")
        let deviceFileUrl = '/file/meter_model.xls'
        let url = `${fileUrl}${deviceFileUrl}`
        if(!fileName || typeof fileName != "string"){
          fileName = this.$t("导出文件")
        }
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        console.log(fileName)
        link.setAttribute('download', fileName+'.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(link.href); //释放掉blob对象
      },
      handleCancel () {
        console.log("handleCancel")
        this.close();
      },
      changeMeterImportType(e) {
        if(e.target.value === 1) {
          this.model = this.$options.data.call(this).model
        }else if(e.target.value === 2) {
          this.queryParam = this.$options.data.call(this).queryParam
        }
      }
    }
  }
</script>

<style scoped>
.ant-form-item >>> .ant-select{
  width: 100%;
}
.span {
  margin: 8px;
}
.background{
  background-color:rgb(238,238,238)
}
.detail-list >>> .content{
  line-height: normal;
}
.form-contain{
  height: 60vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
.form-contain >>> .ant-divider-inner-text{
  color: rgba(24,144,255,0.85);
  font-size: 18px;
  font-weight: bold;
}
</style>